import Vue from 'vue'
import 'babel-polyfill'
import moment from 'moment-timezone'
import store from './store'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import i18n from '@/i18n/i18n'
import VueClipboard from 'vue-clipboard2'
import 'element-ui/lib/theme-chalk/index.css' // 默认主题
import 'font-awesome/css/font-awesome.min.css'
import '@/styles/index.scss' // global css
// import '@/assets/css/icon.css'
// import '@/assets/css/main.css'
import '@/components/common/directives'
import '@/permission'
import { hasPermission } from '@/permission/index.js'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import BaseUI from '@/components/base-ui'
import '@/directives'
import * as filters from './filters' // global filters

Vue.prototype.$moment = moment
Vue.prototype.$size = 'mini'
Vue.prototype.$hasPermission = hasPermission
Vue.prototype.$AppCodeMap = ['mocasa', 'crpt', 'relay', 'cashoyo', 'affiliate']
Vue.prototype.$CountryMap = ['Philippines']
Vue.prototype.$PageTypeMap = {
  0: '不跳转',
  1: 'app',
  2: 'h5'
}
Vue.prototype.$SystemTypeMap = {
  '-1' : '全部',
  '0': '安卓',
  '1': 'IOS',
  '2': 'H5-安卓',
  '3': 'H5-IOS'
}

Vue.prototype.$ProductEntryOptions = {
  1001200: 'Pay Bill',
  1001206: 'E-Voucher',
  1001300: 'Buy Load',
}

// register global utility filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
Vue.use(ElementUI, {
  size: 'small'
})
Vue.use(Viewer)
Vue.use(BaseUI)
Vue.use(VueClipboard)

new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount('#app')

